export const isString = (value: unknown): boolean => {
  return typeof value === 'string';
};
